<template>
  <div class="field">
    <label v-if="label" class="flex flex-col sm:flex-row">
      {{ label }}
      <span v-if="helpText" class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
        {{ helpText }}
      </span>
    </label>

    <currency-input
      :value="checkedValue"
      :placeholder="placeholder"
      locale="en"
      :currency="suffix ? { currency, suffix } : currency"
      :allow-negative="allowNegative"
      :value-as-integer="valueAsInteger"
      :value-range="{ min: min, max: max }"
      :disabled="disabled"
      @input="onChange"
      @focus="onFocusToggle"
      @blur="onFocusToggle"
      :class="[
        'input w-full border block',
        inputClass,
        { 'border-theme-6': hasError },
        { 'mt-2': label },
      ]"
    />

    <HasError v-if="hasError" :vuelidate="vuelidate" :invalidFeedback="invalidFeedback" />
  </div>
</template>

<script>
import baseInputMixin from '@/mixins/baseInputMixin';
import HasError from '@/components/ui/input/HasError';
import { CurrencyInput } from 'vue-currency-input';

export default {
  mixins: [baseInputMixin],

  props: {
    currency: {
      type: String,
      default: 'MNT',
    },
    suffix: {
      type: String,
      default: null,
    },
    allowNegative: {
      type: Boolean,
      default: false,
    },
    valueAsInteger: {
      type: Boolean,
      default: true,
    },
    min: {
      type: Number,
      default: undefined,
    },
    max: {
      type: Number,
      default: undefined,
    },
  },

  data() {
    return {
      isFocused: false,
    };
  },

  computed: {
    checkedValue() {
      if (this.isFocused) {
        return this.value > 0 ? this.value : null;
      }
      return this.value;
    },
  },

  methods: {
    onChange(value) {
      this.$emit('input', value);
    },
    onFocusToggle() {
      this.isFocused = !this.isFocused;
    },
  },

  components: { HasError, CurrencyInput },
};
</script>
